var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#161514",
    fillRule: "evenodd",
    d: "M16.6.45a16.29 16.29 0 0 0-5.14 31.75c.82.15 1.11-.35 1.11-.78l-.02-2.77c-4.53.98-5.49-2.19-5.49-2.19-.74-1.88-1.8-2.38-1.8-2.38-1.48-1.01.1-1 .1-1 1.64.12 2.5 1.69 2.5 1.69 1.45 2.49 3.81 1.77 4.74 1.35a3.48 3.48 0 0 1 1.04-2.18c-3.62-.4-7.42-1.8-7.42-8.05a6.3 6.3 0 0 1 1.67-4.37 5.85 5.85 0 0 1 .16-4.3s1.37-.45 4.48 1.66a15.6 15.6 0 0 1 8.16 0c3.1-2.1 4.47-1.67 4.47-1.67.9 2.24.33 3.9.17 4.31A6.28 6.28 0 0 1 27 15.9c0 6.26-3.8 7.64-7.44 8.04.59.5 1.1 1.5 1.1 3.02l-.01 4.47c0 .43.3.94 1.12.78A16.3 16.3 0 0 0 16.6.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogoBlack);
export default __webpack_public_path__ + "static/media/github-logo-black.de59060b576bca4a882c1889e925697b.svg";
export { ForwardRef as ReactComponent };